import { TableOfContents } from '../../interfaces/TableOfContents';
import { TableOfContentsDto } from '../../interfaces/TableOfContentsDto';

export default function transformData(tableOfContentsDto: TableOfContentsDto): TableOfContents {
  if (!tableOfContentsDto) return null;
  const tableOfContents: TableOfContents =
  {
    title: tableOfContentsDto?.sitecore.route.fields.Title.value,
    introBody: tableOfContentsDto?.sitecore.route.fields.Body.value,
    items: tableOfContentsDto?.sitecore.route.placeholders.main[0].fields[0].items,
  };
  return tableOfContents;
}
